import { porticoApi } from 'store/porticoApi'
import { TOrgnization } from 'types/organizations'
import env from 'utils/general/env'

const organizations = porticoApi.injectEndpoints({
  endpoints: (builder) => ({
    getOrganizations: builder.query<TOrgnization, void>({
      query: () => `v2/organizations/${env?.ORG_NAME}`,
    }),
  }),
})

export const { useGetOrganizationsQuery } = organizations
